import React from 'react';
import {Helmet} from 'react-helmet-async';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Box from 'shared/ui/Box/Box';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';
import useHttpMonitorDetailsView from 'features/http/model/useHttpMonitorDetailsView';

import GeoStatus from './HttpMonitorStatus/GeoStatus/GeoStatus';
import HttpMonitorStatistics from './HttpMonitorStatistics/HttpMonitorStatistics';
import HttpMonitorActions from './HttpMonitorActions/HttpMonitorActions';
import NotificationSettings from './NotificationSettings/NotificationSettings';
import HttpMonitorHeader from '../HttpMonitorHeader/HttpMonitorHeader';

import styles from './HttpMonitorDetails.module.scss';

interface IHttpMonitorDetailsProps {
    item: IHttpMonitorItem,
}

const HttpMonitorDetails: React.FC<IHttpMonitorDetailsProps> = ({item}) => {
    const {tzString, isMobile, backgroundKind} = useHttpMonitorDetailsView(item);

    const backgroundClass = {
        en: styles.enContainer,
        paused: styles.pausedBackground,
        ok: styles.okBackground,
        problem: styles.problemBackground,
    }[backgroundKind];

    return (
        <Box className={cn(
            styles.container,
            backgroundClass,
        )}>
            <Helmet>
                <title>{`${t`Подробности монитора`} ${item.url_human_readable || item.name} | ${t`Overseer`}`}</title>
            </Helmet>
            {
                !isMobile &&
                <>
                    <HttpMonitorHeader item={item} />
                    <span className={styles.line}/>
                </>
            }
            <GeoStatus item={item} />
            <span className={styles.line}/>
            <HttpMonitorStatistics item={item} tzString={tzString} />
            <span className={styles.line} />
            <HttpMonitorActions item={item} />
            <span className={styles.line} />
            <NotificationSettings item={item} />
        </Box>
    );
};

export default HttpMonitorDetails;